import { render, staticRenderFns } from "./bnvnullboolean.vue?vue&type=template&id=41c818da&"
import script from "./bnvnullboolean.vue?vue&type=script&lang=js&"
export * from "./bnvnullboolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports